export default __webpack_public_path__ + "static/niyant-7021cfdab655f7e98b93fde3d3340de0.jpeg";